import "../../styles/vars.scss";
import "../../styles/compo.scss";
import React from "react";
import Buttonz from "../atoms/Buttonz";
import { useDispatch } from "react-redux";
import { showPopup } from "../../redux/actions";

function TopAccess() {
  const dispatch = useDispatch();

  return (
    <>
      <div className="top-access-box">
        <div className="slogan-box">
          UXUI
          <span>DESIGNERS</span>
          <h3>HOME!</h3>
        </div>
        <div className="p-text">
          Join UUD - the ultimate space for UX/UI designers: your hub for
          creative growth, exclusive tools, and insights!
        </div>
        <div className="access-box">
          {!localStorage.getItem("token") ? (
            <>
              <Buttonz
                iconR="login"
                hoverR="login"
                label="Login"
                onClick={() => dispatch(showPopup("login"))}
              />
              <Buttonz
                iconR="user"
                hoverR="user"
                label="Signup"
                className="lined"
                onClick={() => dispatch(showPopup("signup"))}
              />
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default TopAccess;
